import React, { Fragment, useEffect } from "react";
import { clearQuestionDetail, fetchDeleteQuestion } from "../actions/question";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchQuestionList } from "../actions/question";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const QuestionList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "questions";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { questionList } = useSelector((state) => state.questionReducer);

  useEffect(() => {
    dispatch(fetchQuestionList());
    dispatch(clearQuestionDetail());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/question-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteQuestion(pageId));
  };

  //columnDefs za pitanje
  const columnDefs = [
    {
      headerName: t("questionsList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: t("educationList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      minWidth: 150,
    },
    {
      headerName: t("questionsList.educationName"),
      field: "educationName",
      filter: "agTextColumnFilter",
      width: 280,
    },
    {
      headerName: t("questionsList.position"),
      field: "position",
      filter: "agTextColumnFilter",
      width: 120,
    },
    {
      headerName: t("questionsList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("questionsList.statusInactive");
          case "ACTIVE":
            return t("questionsList.statusActive");
          default:
            return "";
        }
      },
      width: 150,
    },
    {
      headerName: t("questionsList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: t("questionsList.updatedAt"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={questionList}
        columnDefs={columnDefs}
        buttonLink={`/question-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"question-list"}
      />
    </Fragment>
  );
};

export default QuestionList;
